import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { RecuperarContrasenaService } from '../_services';
import { first } from 'rxjs/operators';
var CambiarContrasenaComponent = /** @class */ (function () {
    function CambiarContrasenaComponent(formBuilder, route, router, recuperarContrasenaService) {
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.recuperarContrasenaService = recuperarContrasenaService;
        this.submitted = false;
    }
    CambiarContrasenaComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formPassword = this.formBuilder.group({
            nuevaContrasena: [{ value: '', disabled: true }, Validators.required],
            confirmarContrasena: [{ value: '', disabled: true }, Validators.required]
        });
        this.formPassword.setValidators(this.passwordMatchValidator);
        this.error = '';
        this.token = this.route.snapshot.paramMap.get('token');
        console.log(this.token);
        this.recuperarContrasenaService
            .postVerificarRecuperacionContrasena(this.token)
            .pipe(first())
            .subscribe(function (data) {
            if (data['id']) {
                _this.f.nuevaContrasena.enable();
                _this.f.confirmarContrasena.enable();
            }
            else {
                _this.error = data['message'];
                _this.submitted = false;
            }
        });
    };
    Object.defineProperty(CambiarContrasenaComponent.prototype, "f", {
        // convenience getter for easy access to form fields
        get: function () {
            return this.formPassword.controls;
        },
        enumerable: true,
        configurable: true
    });
    CambiarContrasenaComponent.prototype.onSubmit = function () {
        var _this = this;
        this.submitted = true;
        console.log('Submit form cambiar contraseña');
        // stop here if form is invalid
        if (this.formPassword.invalid) {
            return;
        }
        this.recuperarContrasenaService
            .postCambiarContrasena(this.f.nuevaContrasena.value, this.f.confirmarContrasena.value, this.token)
            .pipe(first())
            .subscribe(function (data) {
            if (data['id']) {
                alert('Se ha modificado la contraseña. ');
                _this.submitted = false;
                _this.f.nuevaContrasena.setValue('');
                _this.f.confirmarContrasena.setValue('');
                _this.router.navigate(['/login']);
            }
            else {
                _this.error = data['message'];
                _this.submitted = false;
            }
        });
    };
    CambiarContrasenaComponent.prototype.passwordMatchValidator = function (g) {
        if (g.get('nuevaContrasena').value === g.get('confirmarContrasena').value) {
            g.controls['nuevaContrasena'].setErrors(null);
            return null;
        }
        else {
            g.controls['nuevaContrasena'].setErrors({ mismatch: true });
            return { mismatch: true };
        }
    };
    return CambiarContrasenaComponent;
}());
export { CambiarContrasenaComponent };
